import { DownloadFile } from "../../../Utils/helpers";
import ApiClient from "../api-client";
import { EnvType } from "../services";
import { DbDeliveryMetadataExportInfos } from "../Types/db-delivery-metadata-export-infos";
import { DeliveryMetadataExportOrigin } from "../Types/delivery-metadata-export-origin";
import { ExportOrderDataResponse } from "../Types/export-order-data-response";
import { GenericResponseStd } from "../Types/generic-response-std";
import { GetMetadataExportResponse } from "../Types/get-metadata-export-response";
import { GetMetadataExportsResponse } from "../Types/get-metadata-exports-response";
import { LiquidValidateAndSaveTemplateRequest } from "../Types/liquid-validate-and-save-template-request";
import DataApiClient, { IDataApiClient } from "./data-api-client";

export default class DataService {
  dataApiClient: IDataApiClient;

  constructor(envType: EnvType) {
    this.dataApiClient = new DataApiClient(new ApiClient(envType), envType);
  }

  async GetMetadataExports(): Promise<GetMetadataExportsResponse> {
    return await this.dataApiClient.GetMetadataExports();
  }
  async GetAssetsMetadataExports(): Promise<GetMetadataExportsResponse> {
    return await this.dataApiClient.GetAssetsMetadataExports();
  }
  async GetMetadataExport(id: number): Promise<GetMetadataExportResponse> {
    return await this.dataApiClient.GetMetadataExport(id);
  }
  async CreateMetadataExport(request: DbDeliveryMetadataExportInfos): Promise<GenericResponseStd> {
    return await this.dataApiClient.CreateMetadataExport(request);
  }
  async UpdateMetadataExport(request: DbDeliveryMetadataExportInfos): Promise<GenericResponseStd> {
    return await this.dataApiClient.UpdateMetadataExport(request);
  }
  async DeleteMetadataExport(id: number): Promise<GenericResponseStd> {
    return await this.dataApiClient.DeleteMetadataExport(id);
  }
  async ExportOrderData(itemId: number): Promise<ExportOrderDataResponse> {
    return await this.dataApiClient.ExportOrderData(itemId);
  }
  async RenderTemplate(
    templateId: number,
    resourceId: number,
    resourceType: DeliveryMetadataExportOrigin,
    template: string
  ): Promise<GenericResponseStd> {
    return await this.dataApiClient.RenderTemplate(templateId, resourceId, resourceType, template);
  }
  async LiquidValidateAndSaveTemplate(request: LiquidValidateAndSaveTemplateRequest): Promise<GenericResponseStd> {
    return await this.dataApiClient.LiquidValidateAndSaveTemplate(request);
  }
  async DownloadExportAssetByTemplate(templateId: number, assetId: number): Promise<DownloadExportAssetType> {
    const [fileData, headers] = await this.dataApiClient.ExportAssetByTemplate(templateId, assetId);

    if (headers["content-type"] !== "text/csv" && headers["content-type"] !== "application/zip") {
      return DownloadExportAssetType.EmailLink;
    }

    if (!fileData || fileData.length === 0) return DownloadExportAssetType.Error;
    const headerContentDisp = headers["content-disposition"];
    let fileName = "";
    const headerStartsWith = "attachment; filename=";
    if (headerContentDisp && headerContentDisp.includes(headerStartsWith)) {
      const split = headerContentDisp.substring(headerStartsWith.length).split(";");
      fileName = split[0];
    }

    DownloadFile(fileData, headers["content-type"], fileName);

    return DownloadExportAssetType.DirectDownload;
  }

  //------Utils------
  GetServiceUrl(): string {
    return this.dataApiClient.GetApiUrl();
  }
}

export enum DownloadExportAssetType {
  Error = -1,
  DirectDownload,
  EmailLink,
}
